export default "__VITE_ASSET__BAvMkp4c__"